import React, { useEffect } from 'react'
import { AlertTriangle, Search } from 'react-feather'
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { clearStoreReport, startloadIngresosByOrden } from '../../../../app/store/reportes/thunks';
import { Table } from '../../Table';
import { startloadSaleReport } from '../../../../app/store/sales/thunks';
import { startloadOrden } from '../../../../app/store/ordenes/thunks';

export const IngresosByOrden = () => {
    const dispatch = useDispatch();
    const { register, handleSubmit, reset, setValue, formState: { errors } } = useForm({ model: 'all' });
    const { isLoading, status_report, ingresosByOrden } = useSelector(state => state.reportes);

    useEffect(() => {
        dispatch(clearStoreReport())
    }, [])

    let f = new Date(); let dia = f.getDate(); let mes = f.getMonth() + 1; if (dia < 10) dia = "0" + dia; if (mes < 10) mes = "0" + mes; let today = f.getFullYear() + "-" + mes + "-" + dia;

    const searchOrdenes = (data) => {
        dispatch(startloadIngresosByOrden(data.fechaInicial, data.fechaFinal))
    }

    const loadFolio = (folio) => {

        if (folio.includes("HDLV")) {
            // console.log("La cadena no contiene 'bienvenido'");
            dispatch(startloadSaleReport(folio))
        } else {

            dispatch(startloadOrden(folio));
        }

    }

    let data = [...ingresosByOrden];
    let columns = [
        {
            header: 'FOLIO',
            dataIndex: 'FOLIO',
            classHeader: 'text-start',
            classRow: 'text-start',
            renderer: (value) => (
                <>
                    <button type="button" className="btn btn-link"
                        data-bs-toggle="modal" data-bs-target="#detailFolio"
                        onClick={() => loadFolio(value)}
                    >{value}</button>
                </>
            ),
        },
        {
            header: 'FECHA',
            dataIndex: 'FECHA',
            classHeader: 'text-start',
            classRow: 'text-start',
        },
        {
            header: 'ESTADO',
            dataIndex: 'ESTADO',
            classHeader: 'text-start',
            classRow: 'text-start',
        },
        {
            header: 'GANACIA ESPERADA ($)',
            dataIndex: 'GANANCIA_ESPERADA',
            classHeader: 'text-end',
            classRow: 'text-end',
            renderer: (value) => Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(value),
        },
        {
            header: 'GANACIA REAL ($)',
            dataIndex: 'COBRO_REAL',
            classHeader: 'text-end',
            classRow: 'text-end',
            renderer: (value) => Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(value),
        },

    ];

    return (
        <div>
            <div className="card">
                <div className='card-header border-bottom'>
                    <h4 className=" fw-bold">Ingresos por Orden de Servicio</h4>
                </div>
                <div className="card-body">
                    <form className='row' onSubmit={handleSubmit(searchOrdenes)} >
                        <div className="col-6 col-sm-6 col-md-2 col-lg-2 col-xl-2 col-xxl-2">
                            <label className="form-label">Fecha de Inicio:</label>
                            <input type="date" className="form-control" {...register("fechaInicial", { required: 'Introduce fecha de inicio' })} />
                            {
                                errors.fechaInicial &&
                                <div className='text-left-5 mt-2'>
                                    <AlertTriangle size="18" color="#dc3545" />
                                    <span className='text-left-10 fw-bold text-danger'><small>{errors.fechaInicial.message}</small></span>
                                </div>
                            }
                        </div>
                        <div className="col-6 col-sm-6 col-md-2 col-lg-2 col-xl-2 col-xxl-2  ">
                            <label className="form-label">Fecha de Termino:</label>
                            <input type="date" className="form-control" defaultValue={today} {...register("fechaFinal")} />
                        </div>

                        <div className="col-12 col-sm-12 col-md-2 col-lg-2 col-xl-2 col-xxl-2 mt-1">
                            <div className="mb-3 mt-4">
                                <button type="submit" className="btn btn-outline-secondary">
                                    <Search size="20" /> Buscar
                                </button>
                            </div>
                        </div>
                    </form>
                    <hr className='my-0' />

                    <div className='row mt-3'>
                        <Table columns={columns} data={data} function_={[]} placeholderSearch="Buscar Ingreso" showPagination={false} showControls={true} showTotals={true} />
                    </div>
                </div>
            </div>
        </div>
    )
}
